import api from './axiosInstance';

export const getSellingsApi = (params) => api.get('/user/sellings', { params });
export const getVechanPaymentLogApi       = (params) => api.get('/user/vechan-payment-log', { params });
export const addVechanPaymentLogApi       = (formData) => api.post('/selling/payment', formData);
export const deleteVechanPaymentLogApi    = (id) => api.delete(`/selling/payment/${id}`);
export const updateVechanPaymentImageApi  = (formData) => api.post('/selling/payment/image', formData);
export const createSellingApi = (formData) => api.post('/user/create-selling-new', formData);
export const updateSellingApi = (formData) => api.post('/update-selling-new', formData);
export const deleteSellingApi = (data) => api.delete('/delete-selling-new', { data });
export const updateSellingImageApi = (formData) => api.post('/update-selling-image', formData);
